import { render } from "./AdminMenu.vue?vue&type=template&id=a9bec940"
import script from "./AdminMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMenu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/AdminMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9bec940"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9bec940', __exports__)) {
    api.reload('a9bec940', __exports__)
  }
  
  module.hot.accept("./AdminMenu.vue?vue&type=template&id=a9bec940", () => {
    api.rerender('a9bec940', render)
  })

}


export default __exports__